export const meta = { id: 'O37', slug: 'mentorias-administracao', title: 'Mentorias na visão administrativa', description: 'Entenda como o Owner acompanha a operação de Mentorias sem romper a confidencialidade do acompanhamento.', profile: 'owner', category: 'operacao', type: 'screen', status: 'published', order: 670, keywords: ['mentorias','administração','mentor','mentorado','sessões','confidencialidade'], previous: 'O36', related: ['A12','M10','M11'], updatedAt: '2026-08-17', appVersion: 'v1' }

# Mentorias na visão administrativa

O Owner precisa compreender a operação de Mentorias: Mentores, Mentorados, associações, sessões e funcionamento geral do acompanhamento.

<HelpImage pendingId="O37.1" alt="Visão administrativa de Mentorias" />

## O que a visão administrativa deve preservar

- relações corretas entre Mentor e Mentorado;
- funcionamento das sessões e registros permitidos;
- acompanhamento operacional do ambiente;
- confidencialidade conforme as permissões reais do produto.

<Callout type="important">Ter acesso administrativo não significa que toda informação de Mentoria deixa de ser confidencial. Notas privadas seguem as regras reais de acesso do Personagrama.</Callout>

<Callout type="tip">Para entender a experiência de acompanhamento em detalhe, consulte também os artigos herdados da área de Mentor.</Callout>
